import algoliasearch from 'algoliasearch/lite';
import { createNullCache } from '@algolia/cache-common';
import { createInMemoryCache } from '@algolia/cache-in-memory';
import Places from './places/widget';
import React, { Component } from 'react';
import smoothscroll from 'smoothscroll-polyfill';
import CustomHits from './InfiniteCustomHits';
// import CustomHits from './CustomHits';
import firebase from "firebase";
import {
  InstantSearch,
  connectAutoComplete,
  SearchBox,
  Configure,
  Pagination,
  connectStateResults,
  createInfiniteHitsSessionStorageCache,
  ClearRefinements,
} from 'react-instantsearch-dom';
import { translate } from "react-i18next";
import i18n from '../lang/i18n';

import banner from '../../assets/images/banner.jpg'

const debug = process.env.GATSBY_DEBUG;
const searchRef = React.createRef();
const hitsRef = React.createRef();
const style = {
    backgroundImage: `url(${banner})`
};

if (typeof window !== 'undefined') {
  smoothscroll.polyfill();
}

const algoliaClient = algoliasearch(
  process.env.GATSBY_ALGOLIA_APP_ID,
  process.env.GATSBY_ALGOLIA_SEARCH_KEY,
  {
    // Caches responses from Algolia
    //responsesCache: createInMemoryCache(), // or createNullCache()

    // Caches Promises with the same request payload
    //requestsCache: createInMemoryCache({ serializable: false }), // or createNullCache()
    //aroundLatLngViaIP: true,
  },
);

const index = process.env.GATSBY_ALGOLIA_INDICES_USERS;

const scrollToHits = () => {
  if (hitsRef.current) {
      hitsRef.current.scrollIntoView({ behavior: "smooth" });
  }
}

const searchClient = {
  ...algoliaClient,
  search(requests) {
    //if (debug) console.log(requests);
    if (requests.every(({ params }) => !params.query)) {
      // Here we have to do something else
      //console.log("emptySearch")
    }
    return algoliaClient.search(requests)
  },
};


class MyAutoComplete extends Component {
  constructor(props) {
    super(props);
    this.i18n = i18n;
    this.showMessage = this.showMessage.bind(this);
    this.state = 
    {
        found: "gefunden",
        not_found: "Wir konnten leider kein Woman unter diesem Suchbegriff finden.",
        hits: [],
        userLocation: false,
        ipAddr: null,
    };
  }

  componentDidMount() {
    var that = this;
    i18n.on('loaded', function(loaded) {
      that.setState({
        found: i18n.t("search_found", "gefunden"),
        not_found: i18n.t("search_not_found", "Wir konnten leider kein Woman unter diesem Suchbegriff finden."),
      });
    })
  }

  componentDidUpdate() {
    var that = this;
    i18n.on('languageChanged', function(lng) {
      that.setState({
        found: i18n.t("search_found", "gefunden"),
        not_found: i18n.t("search_not_found", "Wir konnten leider kein Woman unter diesem Suchbegriff finden."),
    });
    })
  }

  showMessage(message) {
    this.setState({
        message: message,
    });
  }
  
  render() {
    const { t } = this.props
    return (
    <div>
    <InstantSearch indexName={index} searchClient={searchClient} ref={searchRef}>
    <section id="banner" className="major" style={style}>
        <div className="inner">
        <header className="major">
            <h1>
              {t("search_banner_title", "Unternehmerinnen einfach finden")}
            </h1>
        </header>
        <div className="content">
                    <p>
                      {t("search_banner_subtitle", "WORLD FULL OF WOMEN weist dir den Weg zu Orten und Erlebnissen, die Frauen geschaffen haben.")}
                    </p>
                  </div>
                  <div className="grid-wrapper">
                    <div className="col-6">
                      <SearchBox 
                              autoFocus={false}
                              showSubmit={false}
                              showReset={false}
                              translations={{
                              submitTitle: 'Suchen.',
                              resetTitle: 'Lösche deinen Suchbegriff.',
                              placeholder: t('search_searchbar_placeholder1', "WAS | WER "),
                          }}/>
                          {/* <ClearRefinements clearsQuery={true}/> */}
                    </div>
                    <div className="col-6">
                      <Places defaultRefinement={{ lat: 52.3677958, lng: 9.7052026 }} />
                    </div>
                    <div className="col-12 center">
                        <div>
                          <br/><br/>
                          <HitAmount found={this.state.found} not_found={this.state.not_found}/>
                          <br/><br/><br/><br/>
                        </div>
                    </div>
                  </div>
            </div>
        </section>
        <div className="cards-top" ref={hitsRef}>
            <Configure hitsPerPage={this.props.amount} filters="isActive:true"/>
                <CustomHitsShuffle hits={this.state.hits} cache={createInfiniteHitsSessionStorageCache()}/>
                {/* <CustomHits/> */}
                <LogCustomStateResults />
            </div>
            {/* <div className="center">
              <span onClick={scrollToHits}><Pagination showLast/></span>
            </div> */}
        </InstantSearch>
      </div>
    );
  }
}


const LogStateResults = ({ searchState }) => {
  var searchTerm = "";
  if (searchState.query) {
    searchTerm = searchState.query;
    firebase.analytics().logEvent('search', {
      search_term: searchTerm,
    });
  }
  return (
    <span></span>
  );
};

const LogCustomStateResults = connectStateResults(LogStateResults);

const HitAmount = connectStateResults(
  ({ searchState, searchResults, props }) =>
    searchResults && searchResults.nbHits !== 0 ? (
      <div>
        {searchState.query ? (
          <div>
          {searchResults.nbHits === 1 ? (<div className="center blend-in"><a onClick={scrollToHits}>{searchResults.nbHits} Woman {props.found}.</a></div>) : (<div className="center blend-in"><a onClick={scrollToHits}>{searchResults.nbHits} Women {props.found}.</a></div>)}
          </div>
        ) : (<div className="center blend-in"><a onClick={scrollToHits} className="icon fa-chevron-down fa-2x"></a></div>)}
      </div>
    ) : (
      <div className="center blend-in">{props.not_found}</div>
    )
);

 const CustomHitsShuffle= connectStateResults(
  ({ searchState, searchResults, props }) =>
    searchResults && searchResults.nbHits !== 0 ? (
      <div>
        <span className={debug ? ("hidden") : ("hidden")}>query: {JSON.stringify(searchState)}</span>
        {/* {searchState.query || searchState.aroundLatLng ? (<CustomHits hits={props.hits} shuffle={false}/>) : (<CustomHits hits={props.hits} shuffle={true}/>)} */}
        {searchState.query || searchState.aroundLatLng ? (<CustomHits hits={props.hits} shuffle={false}/>) : (<CustomHits hits={props.hits} shuffle={false}/>)}
      </div>
    ) : (
      <div className="center blend-in">{props.not_found}</div>
    )
);

const Autocomplete = ({ hits, currentRefinement, refine }) => (
  <>
    <input
      type="search"
      value={currentRefinement}
      onChange={event => refine(event.currentTarget.value)}
    />
  {currentRefinement ? (
      <div className="ad-example-dropdown-menu">
      <div className="ad-example-header">Women:</div>
        <ul>
          {hits.map(hit => (
            <li key={hit.objectID}><a href={"/profile/" + hit.objectID}>{hit.prename} {hit.surname} - {hit.city}</a></li>
          ))}
        </ul>
    </div>
  ) : (<></>)}
  </>
);

const CustomAutocomplete = connectAutoComplete(Autocomplete);


export default translate("Index")(MyAutoComplete)